import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectEntregablesState = ( state: AppState ) => state.entregables;
export const selectEntregables = createSelector(selectEntregablesState, (state) => state);